import { SVGProps } from 'react';

const MasseyRatings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 562.2 108.4" {...props}>
    <path
      fill="#B4EB7A"
      d="M298,0l-24.6,55.8c0,0-12.8,37-62.7,37.8H6l-6,14.9h277.8l24.6-55.8c0,0,13-37.8,55.9-37.8h197.9l6-14.9H298z M552.8,9.9H358.3c-24,0-39.2,11.2-47.7,20.5c-8.6,9.4-12.2,18.8-12.8,20.4l-23.2,52.6H7.4l2-4.9h201.4c51.4-0.8,66-37.4,67.3-40.9 L301.3,5h253.5L552.8,9.9z"
    />
    <g>
      <g>
        <path
          fill="#3B4147"
          d="M37.4,8.3h24.4l-6.8,37.2L75.7,8.3h24.6L74.7,79.1H57.1l14.6-40l-22.9,40H32.9l7.3-42.3L24.8,79.1h-13L37.4,8.3z"
        />
        <path
          fill="#3B4147"
          d="M109.6,30.1h15.6l-7.8,49H104l1.7-8.1h-8.6l-4.2,8.1H81.8L109.6,30.1z M107.4,62.6l3.9-18.9l-9.8,18.9H107.4z"
        />
        <path
          fill="#3B4147"
          d="M147.4,29.6h9.1c3.7,0,6.3,1.1,7.8,3.4c1.5,2.3,1.7,5.2,0.4,8.7l-1.8,5.1h-13.1L152,41c0.3-0.9,0.3-1.6,0-2.1c-0.3-0.5-0.9-0.8-1.7-0.8h-0.7c-0.9,0-1.6,0.2-2.1,0.6c-0.5,0.4-0.9,1.1-1.3,2.2l-1.2,3.5c-0.3,1-0.4,1.8-0.2,2.4c0.2,0.6,0.7,1.1,1.6,1.6l6.2,2.7c5.1,2.4,6.6,6.6,4.5,12.5l-2.4,6.9c-2.2,6.1-6.7,9.1-13.8,9.1h-9.3c-3.7,0-6.4-1.2-7.9-3.5c-1.5-2.3-1.7-5.3-0.4-9l2-5.4h13.3l-2.3,6.4c-0.3,0.9-0.3,1.6,0,2.1c0.3,0.5,0.9,0.8,1.6,0.8h0.9c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.9-1.1,1.3-2.2l1.6-4.5c0.4-1.1,0.5-1.9,0.3-2.4s-0.8-1.1-1.6-1.5l-6.3-2.7c-5.2-2.4-6.7-6.6-4.6-12.5l2.2-5.9C135.9,32.6,140.4,29.6,147.4,29.6z"
        />
        <path
          fill="#3B4147"
          d="M184.4,29.6h9.1c3.7,0,6.3,1.1,7.8,3.4c1.5,2.3,1.7,5.2,0.4,8.7l-1.8,5.1H187l2.2-5.8c0.3-0.9,0.3-1.6,0-2.1c-0.3-0.5-0.9-0.8-1.7-0.8h-0.7c-0.9,0-1.6,0.2-2.1,0.6c-0.5,0.4-0.9,1.1-1.3,2.2l-1.2,3.5c-0.3,1-0.4,1.8-0.2,2.4c0.2,0.6,0.7,1.1,1.6,1.6l6.2,2.7c5.1,2.4,6.6,6.6,4.5,12.5l-2.4,6.9c-2.2,6.1-6.7,9.1-13.8,9.1h-9.3c-3.7,0-6.4-1.2-7.9-3.5c-1.5-2.3-1.7-5.3-0.4-9l2-5.4h13.3l-2.3,6.4c-0.3,0.9-0.3,1.6,0,2.1c0.3,0.5,0.9,0.8,1.6,0.8h0.9c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.9-1.1,1.3-2.2l1.6-4.5c0.4-1.1,0.5-1.9,0.3-2.4c-0.2-0.6-0.8-1.1-1.6-1.5l-6.3-2.7c-5.2-2.4-6.7-6.6-4.6-12.5l2.2-5.9C173,32.6,177.5,29.6,184.4,29.6z"
        />
        <path
          fill="#3B4147"
          d="M211.1,30.1h25.8l-3.3,9.3H221l-3.7,10.1h11.5l-3.3,9.2H214l-4,11h14l-3.3,9.4h-27.4L211.1,30.1z"
        />
        <path
          fill="#3B4147"
          d="M251.5,64.2l-5.4,14.9h-13.8l5.6-15.4l2.1-33.6h14.1l-2.5,18.6l11-18.6h11.3L251.5,64.2z"
        />
      </g>
      <g>
        <path
          fill="#3B4147"
          d="M328.4,30.1h19.9c3.7,0,6.3,1.2,7.8,3.5c1.5,2.3,1.6,5.3,0.3,8.9l-3.9,10.6c-1.4,3.8-3.8,6.4-7.1,7.6l-0.8,18.4h-13.4l2.1-17.4h-3l-6.3,17.4h-13.3L328.4,30.1z M336.9,52.8c0.9,0,1.5-0.2,2.1-0.6c0.5-0.4,0.9-1.1,1.3-2.2l3-8.1c0.3-0.9,0.4-1.6,0.1-2.2c-0.3-0.5-0.8-0.8-1.7-0.8h-3.2l-5,13.8H336.9z"
        />
        <path
          fill="#3B4147"
          d="M373.4,30.1H389l-7.8,49h-13.3l1.7-8.1H361l-4.2,8.1h-11.2L373.4,30.1z M371.3,62.6l3.9-18.9l-9.8,18.9H371.3z"
        />
        <path
          fill="#3B4147"
          d="M401.5,39.7H393l3.5-9.6h30l-3.5,9.6h-8.1l-14.3,39.3h-13.3L401.5,39.7z"
        />
        <path fill="#3B4147" d="M429.6,30.1h13.3l-17.8,49h-13.3L429.6,30.1z" />
        <path
          fill="#3B4147"
          d="M448.1,30.1h14.3l-2,27.1l9.9-27.1h9.6l-17.8,49h-14.3l2-27.1L440,79.1h-9.6L448.1,30.1z"
        />
        <path
          fill="#3B4147"
          d="M481.7,38.7c2.2-6.1,6.8-9.1,13.8-9.1h9.3c3.7,0,6.3,1.2,7.8,3.5c1.5,2.3,1.7,5.3,0.4,8.9l-2.4,6.6h-13.3l2.6-7.1c0.3-0.9,0.3-1.6,0-2.1c-0.3-0.6-0.9-0.8-1.6-0.8h-0.8c-0.9,0-1.5,0.2-2.1,0.6c-0.5,0.4-0.9,1.1-1.3,2.2l-9.6,26.4c-0.3,0.9-0.3,1.6,0,2.1c0.3,0.6,0.9,0.8,1.6,0.8h1.6c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.9-1.1,1.3-2.2l2.5-7h-3.7l3-8.2h16.1l-5.8,16.1c-1.4,3.9-3.2,6.7-5.4,8.4c-2.2,1.6-5.3,2.4-9.2,2.4h-8.9c-3.7,0-6.4-1.2-7.9-3.5c-1.5-2.3-1.6-5.3-0.3-8.9L481.7,38.7z"
        />
        <path
          fill="#3B4147"
          d="M532.6,29.6h9.1c3.7,0,6.3,1.1,7.8,3.4c1.5,2.3,1.7,5.2,0.4,8.7l-1.8,5.1h-13.1l2.2-5.8c0.3-0.9,0.3-1.6,0-2.1c-0.3-0.5-0.9-0.8-1.7-0.8h-0.7c-0.9,0-1.6,0.2-2.1,0.6c-0.5,0.4-0.9,1.1-1.3,2.2l-1.2,3.5c-0.3,1-0.4,1.8-0.2,2.4c0.2,0.6,0.7,1.1,1.6,1.6l6.2,2.7c5.1,2.4,6.6,6.6,4.5,12.5l-2.4,6.9c-2.2,6.1-6.7,9.1-13.8,9.1h-9.3c-3.7,0-6.4-1.2-7.9-3.5c-1.5-2.3-1.7-5.3-0.4-9l2-5.4h13.3l-2.3,6.4c-0.3,0.9-0.3,1.6,0,2.1c0.3,0.5,0.9,0.8,1.6,0.8h0.9c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.9-1.1,1.3-2.2l1.6-4.5c0.4-1.1,0.5-1.9,0.3-2.4c-0.2-0.6-0.8-1.1-1.6-1.5l-6.3-2.7c-5.2-2.4-6.7-6.6-4.6-12.5l2.2-5.9C521.1,32.6,525.6,29.6,532.6,29.6z"
        />
      </g>
    </g>
  </svg>
);
export default MasseyRatings;
